<template>
  <div id="search">
    <div class="layout">
      <div class="stat-type-wrap">
        <div class="search-result-wrap">
          <div class="search-bar-wrap">
            <div class="search-option">
              <select id="searchSort" v-model="sortOrder" name="searchSort">
                <option value="accuracy">정확도순</option>
                <option value="latest">최신순</option>
              </select>
            </div>
            <div class="all-search-box">
              <input type="search" :value="findNm" id="findNm" @input="onSearchInput" @keyup.enter="selectAutocompleteAndSearch" @keydown.down.prevent="moveAutocomplete(1)" @keydown.up.prevent="moveAutocomplete(-1)" @keydown.esc="closeAutocomplete" @blur="onSearchBlur" placeholder="통계자료 검색·키워드를 입력해주세요." autocomplete="off">
              <button type="submit" @click="selectAutocompleteAndSearch"><img src="../../assets/img/ico_main_search2.png" alt="검색하기"></button>
              <ul v-if="showAutocomplete && autocompleteList.length > 0" class="autocomplete-list">
                <li v-for="(item, idx) in autocompleteList" :key="idx" :class="{active: autocompleteIndex === idx}" @mousedown.prevent="applyAutocomplete(item)">{{ item }}</li>
              </ul>
            </div>
          </div>
          <ul class="align-center all-search-tab">
            <li :class="{on: searchTabs === 0}"><a href="#/" @click.prevent="showTotal()">전체</a></li>
            <li :class="{on: searchTabs === 1}"><a href="#/" @click.prevent="showStatics()">통계표</a></li>
            <li :class="{on: searchTabs === 2}"><a href="#/" @click.prevent="showBoard()">게시물</a></li>
            <li :class="{on: searchTabs === 3}"><a href="#/" @click.prevent="showStatReport()">통계보고서</a></li>
            <li :class="{on: searchTabs === 4}"><a href="#/" @click.prevent="showReportTag()">통계보고서 분류</a></li>
          </ul>
          <!-- 전체검색 결과 -->
          <div v-show="searchTabs === 0">
            <!-- 통계표 검색결과 -->
            <div class="search-result date-none">
              <div class="search-section-header">
                <span class="section-title">
                  <span class="section-icon section-icon--stat">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="9" x2="9" y2="21"/></svg>
                  </span>
                  <span class="total">통계표 검색결과 <span class="num">{{ numberFormat(staticTotalCnt) }}</span>건</span>
                </span>
                <a href="#/" class="more-btn" @click.prevent="showStatics()">더보기</a>
              </div>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">제목</span>
                  <span class="search-col-left">최근 입력연도</span>
                  <span class="search-col-right">조사명</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in staticResultList" :key="idx" class="search-result-item">
                    <a href="#/" @click.prevent="staticDetail(data.svyMgmNo, data.tblMgmNo, data.statPath, data.tblKorNm, data.cmmtDesc)" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge">{{ data.tblTypeNm }}</span>
                        <span class="search-data-title-text" v-html="data.tblKorNm"></span>
                        <span class="search-data-path-text"> 목록 : <span v-html="formatPath(data.statPath)"></span></span>
                        <span class="search-data-path-text"> 전체 입력연도 : <span v-html="formatPath(data.tblYearMonth)"></span></span>
                      </span>
                      <span class="search-col-left-text" :title="data.tblYearMonth">{{ data.tblYearMonth ? data.tblYearMonth.split(',')[0] : '' }}</span>
                      <span class="search-col-right-text">{{ data.svyMgmNm }}</span>
                    </a>
                  </li>
                  <li v-show="!staticResultList || staticResultList.length === 0">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.page, this.staticTotalCnt, this.rows)" @paging="pagingMethod"/>
            </div>
            <!-- 게시글 검색결과 -->
            <div class="search-result date-none">
              <div class="search-section-header">
                <span class="section-title">
                  <span class="section-icon section-icon--board">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                  </span>
                  <span class="total">게시물 검색결과 <span class="num" style="color: #0e7c42">{{ numberFormat(boardTotalCnt) }}</span>건</span>
                </span>
                <a href="#/" class="more-btn" @click.prevent="showBoard()">더보기</a>
              </div>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">제목</span>
                  <span class="search-col-left">종류</span>
                  <span class="search-col-right">등록일</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in boardResultList" :key="idx" class="search-result-item">
                    <a v-if="data.boardType === '000266'" href="#/" @click.prevent="goInfographic(data.descriptionUrl)" class="search-item-row">
                        <span class="search-col-title">
                        <span class="search-data-badge">인포그래픽</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">인포그래픽</span>
                      <span class="search-col-right-text"></span>
                    </a>
                    <router-link v-else-if="data.boardType === '000035'" class="search-item-row" :to="{name: '기타자료실 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '기타 자료실'}}">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">기타 자료실</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">기타 자료실</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                    <router-link v-else-if="data.boardType === '000036'" class="search-item-row" :to="{name: '공지사항 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '공지사항'}}">
                       <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">공지사항</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">공지사항</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                    <router-link v-else-if="data.boardType === '000311'" class="search-item-row" :to="{name: '지표보고서 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '지표보고서'}}">
                       <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">지표보고서</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">지표보고서</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                  </li>
                  <li v-show="boardResultList == null || boardResultList == ''">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.boardPage, this.boardTotalCnt, this.boardRows)" @paging="pagingBoardMethod"/>
            </div>
            <!-- 통계보고서 검색결과 -->
            <div class="search-result date-none">
              <div class="search-section-header">
                <span class="section-title">
                  <span class="section-icon section-icon--report">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
                  </span>
                  <span class="total">통계보고서 검색결과 <span class="num" style="color: #6951b8">{{ numberFormat(statReportTotalCnt) }}</span>건</span>
                </span>
                <a href="#/" class="more-btn" @click.prevent="showStatReport()">더보기</a>
              </div>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">보고서명</span>
                  <span class="search-col-left">종류</span>
                  <span class="search-col-right">등록일</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in statReportResultList" :key="idx" class="search-result-item">
                    <a href="#/" @click.prevent="goStatReport(data)" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #6951b8">통계보고서</span>
                        <span class="search-data-title-text" v-html="data.name"></span>
                      </span>
                      <span class="search-col-left-text">통계보고서</span>
                      <span class="search-col-right-text">{{ formatDate(data.regDate) }}</span>
                    </a>
                  </li>
                  <li v-show="!statReportResultList || statReportResultList.length === 0">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.statReportPage, this.statReportTotalCnt, this.statReportRows)" @paging="pagingStatReportMethod"/>
            </div>
            <!-- 통계보고서 분류 검색결과 -->
            <div class="search-result date-none">
              <div class="search-section-header">
                <span class="section-title">
                  <span class="section-icon section-icon--tag">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                  </span>
                  <span class="total">통계보고서 분류 검색결과 <span class="num" style="color: #d06000">{{ numberFormat(reportTagTotalCnt) }}</span>건</span>
                </span>
                <a href="#/" class="more-btn" @click.prevent="showReportTag()">더보기</a>
              </div>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">보고서명</span>
                  <span class="search-col-left">저자</span>
                  <span class="search-col-right">발간연도</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in reportTagResultList" :key="idx" class="search-result-item">
                    <router-link :to="{name: '통계 보고서 상세', params: {anlDetailNo: data.anlDetailNo}}" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #d06000">{{ data.anlClsNm }}</span>
                        <span class="search-data-title-text" v-html="showReportTagTitle(data)"></span>
                        <span class="search-data-path-text"> <span v-html="showReportTagNavigation(data)"></span></span>
                      </span>
                      <span class="search-col-left-text">{{ data.rptAuthNm }}</span>
                      <span class="search-col-right-text">{{ formatDate(data.rptPubYear) }}</span>
                    </router-link>
                  </li>
                  <li v-show="!reportTagResultList || reportTagResultList.length === 0">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.reportTagPage, this.reportTagTotalCnt, this.reportTagRows)" @paging="pagingReportTagMethod"/>
            </div>
          </div>
          <!-- 통계표 검색 결과 -->
          <div v-show="searchTabs === 1">
            <div class="align-between all-search-title">
              <h3>통계표</h3>
            </div>
            <div class="btn-layout right">
              <button type="button" class="indigo btn small" @click.prevent="searchResult()">검색결과</button>
              <button type="button" class="indigo btn small" @click.prevent="searchShowDetail()">상세검색</button>
            </div>
            <div v-show="showStaticResult">
              <div class="search-result date-none">
                <span class="section-title">
                  <span class="section-icon section-icon--stat">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="9" x2="9" y2="21"/></svg>
                  </span>
                  <span class="total">통계표 검색결과 <span class="num">{{ numberFormat(tabTotalCnt) }}</span>건</span>
                </span>
                <div class="search-table-wrap">
                  <div class="search-col-header">
                    <span class="search-col-title">제목</span>
                    <span class="search-col-left">최근 입력연도</span>
                    <span class="search-col-right">조사명</span>
                  </div>
                  <ul class="search-result-list">
                    <li v-for="(data, idx) in tabResultList" :key="idx" class="search-result-item">
                      <a href="#/" @click.prevent="staticDetail(data.svyMgmNo, data.tblMgmNo, data.statPath, data.tblKorNm, data.cmmtDesc)" class="search-item-row">
                        <span class="search-col-title">
                        <span class="search-data-badge">{{ data.tblTypeNm }}</span>
                        <span class="search-data-title-text" v-html="data.tblKorNm"></span>
                        <span class="search-data-path-text"> 목록 : <span v-html="formatPath(data.statPath)"></span></span>
                        <span class="search-data-path-text"> 전체 입력연도 : <span v-html="formatPath(data.tblYearMonth)"></span></span>
                      </span>
                        <span class="search-col-left-text" :title="data.tblYearMonth">{{ data.tblYearMonth ? data.tblYearMonth.split(',')[0] : '' }}</span>
                        <span class="search-col-right-text">{{ data.svyMgmNm }}</span>
                      </a>
                    </li>
                    <li v-show="!tabResultList || tabResultList.length === 0">
                      <div class="search-item-row no-data-row" style="cursor:default;">
                        <span class="no-data-text">검색결과가 없습니다.</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <SearchPagination :pageSetting="pageDataSetting(this.tabPage, this.tabTotalCnt, this.tabRows)" @paging="pagingTabMethod"/>
              </div>
            </div>
            <!-- 상세검색 -->
            <div v-show="showDetail">
              <SearchStatDetail ref="searchStatDetail" />
            </div>
          </div>
          <!-- 게시물 검색 결과 -->
          <div v-show="searchTabs === 2">
            <div class="search-result date-none">
              <div class="search-section-header">
                <span class="section-title">
                  <span class="section-icon section-icon--board">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                  </span>
                  <span class="total">게시물 검색결과 <span class="num" style="color: #0e7c42">{{ numberFormat(tabBoardTotalCnt) }}</span>건</span>
                </span>
              </div>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">제목</span>
                  <span class="search-col-left">종류</span>
                  <span class="search-col-right">등록일</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in tabBoardResultList" :key="idx" class="search-result-item">
                    <a v-if="data.boardType === '000266'" href="#/" @click.prevent="goInfographic(data.descriptionUrl)" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge">인포그래픽</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">인포그래픽</span>
                      <span class="search-col-right-text"></span>
                    </a>
                    <router-link v-else-if="data.boardType === '000035'" class="search-item-row" :to="{name: '기타자료실 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '기타 자료실'}}">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">기타 자료실</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">기타 자료실</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                    <router-link v-else-if="data.boardType === '000036'" class="search-item-row" :to="{name: '공지사항 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '공지사항'}}">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">공지사항</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">공지사항</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                    <router-link v-else-if="data.boardType === '000311'" class="search-item-row" :to="{name: '지표보고서 상세', query: {boardId: data.boardId, boardType: data.boardType, target: '지표보고서'}}">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #0e7c42">지표보고서</span>
                        <span class="search-data-title-text" v-html="data.boardTitle"></span>
                      </span>
                      <span class="search-col-left-text">지표보고서</span>
                      <span class="search-col-right-text">{{ formatDate(data.fstRegDate) }}</span>
                    </router-link>
                  </li>
                  <li v-show="tabBoardResultList == null || tabBoardResultList == ''">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.tabBoardPage, this.tabBoardTotalCnt, this.tabBoardRows)" @paging="pagingTabBoardMethod"/>
            </div>
          </div>
          <!-- 통계보고서 검색 결과 -->
          <div v-show="searchTabs === 3">
            <div class="search-result date-none">
              <span class="section-title">
                <span class="section-icon section-icon--report">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
                </span>
                <span class="total">통계보고서 검색결과 <span class="num" style="color: #6951b8">{{ numberFormat(tabStatReportTotalCnt) }}</span>건</span>
              </span>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">보고서명</span>
                  <span class="search-col-left">종류</span>
                  <span class="search-col-right">등록일</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in tabStatReportResultList" :key="idx" class="search-result-item">
                    <a href="#/" @click.prevent="goStatReport(data)" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #6951b8">통계보고서</span>
                        <span class="search-data-title-text" v-html="data.name"></span>
                      </span>
                      <span class="search-col-left-text">통계보고서</span>
                      <span class="search-col-right-text">{{ formatDate(data.regDate) }}</span>
                    </a>
                  </li>
                  <li v-show="!tabStatReportResultList || tabStatReportResultList.length === 0">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.tabStatReportPage, this.tabStatReportTotalCnt, this.tabStatReportRows)" @paging="pagingTabStatReportMethod"/>
            </div>
          </div>
          <!-- 통계보고서 분류 검색 결과 -->
          <div v-show="searchTabs === 4">
            <div class="search-result date-none">
              <span class="section-title">
                <span class="section-icon section-icon--tag">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
                </span>
                <span class="total">통계보고서 분류 검색결과 <span class="num" style="color: #d06000">{{ numberFormat(tabReportTagTotalCnt) }}</span>건</span>
              </span>
              <div class="search-table-wrap">
                <div class="search-col-header">
                  <span class="search-col-title">보고서명</span>
                  <span class="search-col-left">저자</span>
                  <span class="search-col-right">발간연도</span>
                </div>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in tabReportTagResultList" :key="idx" class="search-result-item">
                    <router-link :to="{name: '통계 보고서 상세', params: {anlDetailNo: data.anlDetailNo}}" class="search-item-row">
                      <span class="search-col-title">
                        <span class="search-data-badge" style="background-color: #d06000">{{ data.anlClsNm }}</span>
                        <span class="search-data-title-text" v-html="showReportTagTitle(data)"></span>
                        <span class="search-data-path-text"> <span v-html="showReportTagNavigation(data)"></span></span>
                      </span>
                      <span class="search-col-left-text">{{ data.rptAuthNm }}</span>
                      <span class="search-col-right-text">{{ formatDate(data.rptPubYear) }}</span>
                    </router-link>
                  </li>
                  <li v-show="!tabReportTagResultList || tabReportTagResultList.length === 0">
                    <div class="search-item-row no-data-row" style="cursor:default;">
                      <span class="no-data-text">검색결과가 없습니다.</span>
                    </div>
                  </li>
                </ul>
              </div>
              <SearchPagination :pageSetting="pageDataSetting(this.tabReportTagPage, this.tabReportTagTotalCnt, this.tabReportTagRows)" @paging="pagingTabReportTagMethod"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/Statistics.js'
import * as searchApi from '@/api/Search.js'
import * as statReportApi from '@/api/StatReport.js'
import * as noticeApi from '@/api/Notice.js'
import $, { param } from 'jquery'
import SearchPagination from '@/components/SearchPagination'
import SearchStatDetail from '@/components/SearchStatDetail'
import DataMapChart from '@/components/chart/DataMapChart'
import SubjectNameUtil from "@/assets/js/SubjectNameUtil";

export default {
  name: 'Search',

  components: {
    SearchPagination,
    SearchStatDetail,
    DataMapChart
  },

  data () {
    return {
      searchTabs: 0, // 공통 탭 제어 (0:전체, 1:통계표, 2:게시물, 3:통계보고서, 4:MDSS)
      showStaticResult: false,
      showDetail: false,
      sortOrder: 'accuracy',
      findNm: '',
      autocompleteList: [],
      showAutocomplete: false,
      autocompleteIndex: -1,
      autocompleteTimer: null,
      searchFindNm: this.$route.query.searchFindNm,
      block: 10,
      // 통합검색 데이터 - 통계표
      staticResultList: [],
      staticTotalCnt: 0,
      rows: 3,
      page: 1,
      // 통합검색 데이터 - 게시물
      boardResultList: [],
      boardTotalCnt: 0,
      boardRows: 3,
      boardPage: 1,
      // 통합검색 데이터 - 통계보고서
      statReportResultList: [],
      statReportTotalCnt: 0,
      statReportRows: 3,
      statReportPage: 1,
      // 통합검색 데이터 - 통계보고서 분류
      reportTagResultList: [],
      reportTagTotalCnt: 0,
      reportTagRows: 3,
      reportTagPage: 1,
      // 통계표 탭 검색 데이터
      tabResultList: [],
      tabTotalCnt: 0,
      tabRows: 10,
      tabPage: 1,
      // 게시물 탭 검색 데이터
      tabBoardResultList: [],
      tabBoardTotalCnt: 0,
      tabBoardRows: 10,
      tabBoardPage: 1,
      boardOrder: '01',
      // 통계보고서 탭 검색 데이터
      tabStatReportResultList: [],
      tabStatReportTotalCnt: 0,
      tabStatReportRows: 10,
      tabStatReportPage: 1,
      // 통계보고서 분류 탭 검색 데이터
      tabReportTagResultList: [],
      tabReportTagTotalCnt: 0,
      tabReportTagRows: 10,
      tabReportTagPage: 1
    }
  },

  created () {
    if (this.searchFindNm != undefined) {
      this.findNm = this.searchFindNm
    }
    this.searchRetrieve(this.page, 0)
  },

  mounted () {
    if (window.innerWidth <= 768) {
      this.block = 5
    }
  },

  watch: {
    $route (to, from) {
      if (to.path == from.path) {
        if (this.$route.query.searchFindNm != undefined) {
          this.findNm = this.$route.query.searchFindNm
        }
        this.searchRetrieve(this.page, 0)
      }
    }
  },

  methods: {
    onSearchInput (event) {
      this.findNm = event.target.value
      this.fetchAutocomplete()
    },

    fetchAutocomplete () {
      clearTimeout(this.autocompleteTimer)
      this.autocompleteIndex = -1
      if (!this.findNm || this.findNm.trim().length < 2) {
        this.closeAutocomplete()
        return
      }
      this.autocompleteTimer = setTimeout(async () => {
        try {
          const res = await searchApi.selectAutocomplete({ searchKeyword: this.findNm, size: 5 })
          this.autocompleteList = res.data.searchAutocompleteList || []
          this.showAutocomplete = this.autocompleteList.length > 0
        } catch (e) {
          this.closeAutocomplete()
        }
      }, 300)
    },

    moveAutocomplete (dir) {
      if (!this.showAutocomplete) return
      const max = this.autocompleteList.length - 1
      this.autocompleteIndex = Math.max(-1, Math.min(max, this.autocompleteIndex + dir))
    },

    applyAutocomplete (item) {
      this.findNm = item
      this.closeAutocomplete()
      this.searchRetrieve(1, 0)
    },

    selectAutocompleteAndSearch () {
      clearTimeout(this.autocompleteTimer)
      if (this.autocompleteIndex >= 0 && this.autocompleteList[this.autocompleteIndex]) {
        this.applyAutocomplete(this.autocompleteList[this.autocompleteIndex])
      } else {
        this.closeAutocomplete()
        this.searchRetrieve(1, 0)
      }
    },

    closeAutocomplete () {
      this.showAutocomplete = false
      this.autocompleteIndex = -1
    },

    onSearchBlur () {
      clearTimeout(this.autocompleteTimer)
      setTimeout(() => { this.closeAutocomplete() }, 150)
    },

    searchRetrieve (currentPage, startPage) {

      this.searchStaticResult(currentPage, startPage)
      this.searchBoardResult(currentPage, startPage)
      this.searchStatReportResult(currentPage, startPage)
      this.searchReportTagResult(currentPage, startPage)
      this.searchTabResult(currentPage, startPage)
      this.searchTabBoardResult(currentPage, startPage)
      this.searchTabStatReportResult(currentPage, startPage)
      this.searchTabReportTagResult(currentPage, startPage)

      if (this.searchTabs === 1) {
        this.showStaticResult = true
      }

      //인기 검색어 저장
      this.insertSrchLang();
      this.$router.push({name: '통합검색', query: {searchFindNm: this.findNm}});
    },

    // 인기검색어 저장
    async insertSrchLang () {
      if (this.findNm != '') {
        const param = {
          findNm: this.findNm
        }
        await searchApi.insertSrchLang(param)
      }
    },

    // ===== 전체 검색 (통계표)
    async searchStaticResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.staticResultList = []
        this.staticTotalCnt = 0
        return false
      }

      const param = {
        rows: this.rows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'stat',
        scn: 'stat',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.staticResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.staticTotalCnt = searchList.data[0].totalCount
      } else {
        this.staticTotalCnt = 0
      }

      this.page = currentPage
      this.pageDataSetting(currentPage, this.staticTotalCnt, this.rows)
    },

    numberFormat(value) {
      if(!value) return '0';
      const numberValue = Number(value);
      return numberValue.toLocaleString();
    },

    formatDate(value) {
      if (!value) return '';
      return String(value).split(' ')[0];
    },

    pageDataSetting (currentPage, totalCnt, rows) {
      const totalPage = Math.ceil(totalCnt / rows)
      const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
      const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

      const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
      const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
      const list = []

      for (let index = startIndex; index <= endIndex; index++) {
        list.push(index)
      }

      return { first, end, list, currentPage, totalPage }
    },

    pagingMethod (page) {
      const startRow = page - 1
      this.searchStaticResult(page, startRow)
    },

    // ===== 탭 검색 (통계표)
    async searchTabResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.tabResultList = []
        this.tabTotalCnt = 0
        return false
      }

      const param = {
        rows: this.tabRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'stat',
        scn: 'stat',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.tabResultList = searchList.data
      if (searchList.data && searchList.data.length > 0) {
        this.tabTotalCnt = searchList.data[0].totalCount
      } else {
        this.tabTotalCnt = 0
      }

      this.tabPage = currentPage
      this.pageDataSetting(currentPage, this.tabTotalCnt, this.tabRows)
    },

    pagingTabMethod (page) {
      const startRow = page - 1
      this.searchTabResult(page, startRow)
    },

    // ===== 전체 검색 (게시글)
    async searchBoardResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.boardResultList = []
        this.boardTotalCnt = 0
        return false
      }

      const param = {
        rows: this.boardRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'board',
        scn: 'board',
        boardOrder: '01',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.boardResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.boardTotalCnt = searchList.data[0].totalCount
      } else {
        this.boardTotalCnt = 0
      }

      this.boardPage = currentPage
      this.pageDataSetting(currentPage, this.boardTotalCnt, this.boardRows)
    },

    pagingBoardMethod (page) {
      const startRow = page - 1
      this.searchBoardResult(page, startRow)
    },

    // ===== 탭 검색 (게시글)
    async searchTabBoardResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.tabBoardResultList = []
        this.tabBoardTotalCnt = 0
        return false
      }

      const param = {
        rows: this.tabBoardRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'board',
        scn: 'board',
        boardOrder: this.boardOrder,
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.tabBoardResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.tabBoardTotalCnt = searchList.data[0].totalCount
      } else {
        this.tabBoardTotalCnt = 0
      }

      this.tabBoardPage = currentPage
      this.pageDataSetting(currentPage, this.tabBoardTotalCnt, this.tabBoardRows)
    },

    pagingTabBoardMethod (page) {
      const startRow = page - 1
      this.searchTabBoardResult(page, startRow)
    },

    // 게시판(인포그래픽) 상세 보기
    goInfographic (url) {
      window.open(url)
    },

    // 게시물 탭 정렬 순서 변경
    searchBoardOrder () {
      this.searchTabBoardResult(1, 0)
    },

    // 통계표 목록 Path 변경
    formatPath (path) {
      return path ? path.replace(/>>/g, ' > ') : ''
    },

    getBoardTypeName (boardType) {
      const map = { '000266': '인포그래픽', '000035': '기타 자료실', '000036': '공지사항', '000311': '지표보고서' }
      return map[boardType] || '게시물'
    },

    // ===== 전체 검색 (통계보고서)
    async searchStatReportResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.statReportResultList = []
        this.statReportTotalCnt = 0
        return false
      }

      const param = {
        rows: this.statReportRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'statReport',
        scn: 'statReport',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.statReportResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.statReportTotalCnt = searchList.data[0].totalCount
      } else {
        this.statReportTotalCnt = 0
      }

      this.statReportPage = currentPage
      this.pageDataSetting(currentPage, this.statReportTotalCnt, this.statReportRows)
    },

    pagingStatReportMethod (page) {
      const startRow = page - 1
      this.searchStatReportResult(page, startRow)
    },

    // ===== 탭 검색 (통계보고서)
    async searchTabStatReportResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.tabStatReportResultList = []
        this.tabStatReportTotalCnt = 0
        return false
      }

      const param = {
        rows: this.tabStatReportRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'statReport',
        scn: 'statReport',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.tabStatReportResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.tabStatReportTotalCnt = searchList.data[0].totalCount
      } else {
        this.tabStatReportTotalCnt = 0
      }

      this.tabStatReportPage = currentPage
      this.pageDataSetting(currentPage, this.tabStatReportTotalCnt, this.tabStatReportRows)
    },

    pagingTabStatReportMethod (page) {
      const startRow = page - 1
      this.searchTabStatReportResult(page, startRow)
    },

    // 통계보고서 상세보기 (팝업)
    async goStatReport (data) {
      // 통계보고서 방문자수 업데이트
      this.updateVistCount(data)

      if (data.siteclass) {
        let openUrl = `/portal/skin/doc.html?fn=${data.siteclass}&rs=/portal/viewer/`;
        window.open(openUrl, '_blank')
      }
    },

    // 통계보고서 방문자수 업데이트
    async updateVistCount (data) {
      const frm = new FormData()
      frm.append('statRptId', data.statRptId)
      statReportApi.updateStatReportVistCount(frm)
      data.visitCnt = Number(data.visitCnt) + 1
    },

    // ===== 전체 검색 (통계보고서 분류)
    async searchReportTagResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.reportTagResultList = []
        this.reportTagTotalCnt = 0
        return false
      }

      const param = {
        rows: this.reportTagRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'statReportTag',
        scn: 'statReportTag',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.reportTagResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.reportTagTotalCnt = searchList.data[0].totalCount
      } else {
        this.reportTagTotalCnt = 0
      }

      this.reportTagPage = currentPage
      this.pageDataSetting(currentPage, this.reportTagTotalCnt, this.reportTagRows)
    },

    pagingReportTagMethod (page) {
      const startRow = page - 1
      this.searchReportTagResult(page, startRow)
    },

    // ===== 탭 검색 (통계보고서 분류)
    async searchTabReportTagResult (currentPage, startPage) {
      if (this.findNm == '') {
        this.tabReportTagResultList = []
        this.tabReportTagTotalCnt = 0
        return false
      }

      const param = {
        rows: this.tabReportTagRows,
        findNm: this.findNm,
        startPage: startPage,
        typeNm: 'statReportTag',
        scn: 'statReportTag',
        sortOrder: this.sortOrder
      }

      const searchList = await searchApi.selectRetrieve(param)
      this.tabReportTagResultList = searchList.data

      if (searchList.data && searchList.data.length > 0) {
        this.tabReportTagTotalCnt = searchList.data[0].totalCount
      } else {
        this.tabReportTagTotalCnt = 0
      }

      this.tabReportTagPage = currentPage
      this.pageDataSetting(currentPage, this.tabReportTagTotalCnt, this.tabReportTagRows)
    },

    pagingTabReportTagMethod (page) {
      const startRow = page - 1
      this.searchTabReportTagResult(page, startRow)
    },

    // 전체 탭 클릭 시
    showTotal () {
      this.searchTabs = 0
    },

    // 통계표 탭 클릭 시
    showStatics () {
      this.searchTabs = 1 // 통계표 탭 on
      this.showStaticResult = true
    },

    // 통계표 새 창 띄우기
    staticDetail (svyMgmNo, tblMgmNo, path, name, cmmtDesc) {
      const statName = String(name).replace('<b>','').replace('</b>', '')
      const statPath = String(path).replace('<b>','').replace('</b>', '')
      const subjectName = statPath.split('>>').at();
      const subjectPath = SubjectNameUtil.getSubjectPathByName(subjectName);
      const isSubject = subjectPath.indexOf('subject') > -1;

      if (isSubject) {
        if(svyMgmNo === 'STBL-1014278'){
          window.open(cmmtDesc)
        }else{
          const targetPath = `/portal/subject/${subjectPath}/${svyMgmNo}/stat/${tblMgmNo}`;
          window.open(targetPath);
        }
      } else {
        let indexTargetPath = '';
        switch (statName) {
          case '소비자물가지수':
          case '서비스업생산지수':
          case '가계지출동향':
          case '고용동향':
            indexTargetPath = `/portal/index/index01/${svyMgmNo}`;
            break;
          default:
            indexTargetPath = `/portal/index/index01/${svyMgmNo}/stat/${tblMgmNo}`;
        }

        window.open(indexTargetPath);
      }
    },

    // 검색결과 클릭 시
    searchResult () {
      this.showStaticResult = true
      this.showDetail = false
    },

    // 상세검색 클릭 시
    searchShowDetail () {
      this.showStaticResult = false
      this.showDetail = true
    },

    showBoard () {
      this.searchTabs = 2
    },

    showStatReport () {
      this.searchTabs = 3
    },

    showReportTag () {
      this.searchTabs = 4
    },

    showReportTagTitle(data) {
      let title = "";
      switch (data.rstContentsType) {
        case "I":
          title = data.indexNm;
          break;
        case "S":
          title = data.sessionNm;
          break;
        case "C":
          title = data.chapterNm;
          break;
      }
      return title;
    },

    showReportTagNavigation(data) {
      let title = "";
      switch (data.rstContentsType) {
        case "I":
          title =
            data.anlMstNm +
            " > " +
            data.chapterNm +
            " > " +
            data.sessionNm +
            " > " +
            data.indexNm;
          break;
        case "S":
          title =
            title =
              data.anlMstNm +
              " > " +
              data.chapterNm +
              " > " +
              data.sessionNm;
          break;
        case "C":
          title =
            title =
              data.anlMstNm +
              " > " +
              data.chapterNm;
          break;
      }
      return title;
    },
  }

}
</script>

<style scoped>
/* 검색바 한 줄 레이아웃 */
.search-bar-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 60px auto 0;
  width: 100%;
  max-width: 700px;
}
.all-search-box {
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
  border: 1px solid #666666;
  border-radius: 6px;
  padding: 0 15px 0 10px;
  margin: 0px;
}
.all-search-box input[type='search'] {
  flex: 1;
  width: auto;
  border-bottom: 0;
}
.all-search-box button[type='submit'] {
  position: static;
  transform: none;
  flex-shrink: 0;
}
@media only screen and (max-width: 768px) {
  .search-bar-wrap {
    max-width: 100%;
    margin: 20px auto 0;
    gap: 8px;
  }
}

/* 섹션 박스 테두리 */
.search-result.date-none {
  border: 1px solid #dde0e8;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* 섹션 헤더: 건수 + 더보기 버튼 */
.search-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

/* 아이콘 + 타이틀 묶음 */
.section-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* section-title이 헤더 없이 단독으로 쓰일 때 여백 */
.search-result.date-none > .section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

/* 섹션 아이콘 박스 */
.section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  flex-shrink: 0;
  color: #fff;
}

.section-icon--stat   { background-color: #1a4099; }
.section-icon--board  { background-color: #0e7c42; }
.section-icon--report { background-color: #6951b8; }
.section-icon--tag    { background-color: #d06000; }

.more-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 13px;
  color: #555;
  text-decoration: none;
  white-space: nowrap;
}

.more-btn::after {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23555555' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='9 18 15 12 9 6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
}

.more-btn:hover {
  color: #003087;
  text-decoration: underline;
}

.more-btn:hover::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23003087' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='9 18 15 12 9 6'/%3E%3C/svg%3E");
}

/* 통계표 / 게시물 / 통계보고서 / 통계보고서 분류 컬럼 헤더 */
.search-col-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f5f6fa;
  border-top: 2px solid #333;
  border-bottom: 1px solid #ddd;
  padding: 15px 12px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

.search-col-header .search-col-title,
.search-col-header .search-col-left,
.search-col-header .search-col-right {
  text-align: center;
  justify-content: center;
}

/* 검색결과 목록 */
.search-result-list {
  padding: 0;
  margin: 0 0 10px;
  list-style: none;
}

.search-result-item {
  border-bottom: 1px solid #eee;
}

.search-item-row {
  display: flex;
  align-items: center;
  padding: 20px 12px;
  text-decoration: none;
  color: inherit;
  gap: 12px;
}

.search-item-row:hover .search-col-title {
  color: #ff6600;
}

/* 컬럼 너비 (헤더·행 공유) */
.search-col-title {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-col-title::v-deep b { color: #ff6600; }

.search-col-left {
  width: 100px;
  flex-shrink: 0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-col-right {
  width: 140px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.search-data-badge {
  display: inline-block;
  align-self: flex-start;
  padding: 5px 10px;
  border: 1px solid #fff;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 300;
  color: #fff;
  white-space: nowrap;
  background-color: #1a4099;
}

.search-data-title-text {
  display: inline-block;
  width: 1100px;
  font-size: 22px;
  font-weight: 600;
  color: #3f3f89;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-data-title-text::v-deep b { color: #ff6600; }

.search-data-path-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #888;
}

.search-col-left-text {
  width: 100px;
  flex-shrink: 0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  color: #444;
}

.search-col-right-text {
  width: 140px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 15px;
  color: #444;
}

/* 공통 */
.no-data-row {
  justify-content: center;
  padding: 20px 0;
}

.no-data-text {
  color: #888;
  font-size: 14px;
}

/* 게시물 탭 정렬 옵션 */
.orderby-radio-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
}

/* 자동완성 */
.autocomplete-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0px;
  background: #fff;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
  z-index: 9999;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 250px;
  overflow-y: auto;
}

.autocomplete-list li {
  padding: 15px 16px;
  cursor: pointer;
  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.autocomplete-list li:last-child {
  border-bottom: none;
}

.autocomplete-list li:hover,
.autocomplete-list li.active {
  background-color: #f5f5f5;
  color: #003087;
}

/* 정렬 셀렉트 */
.search-option {
  position: relative;
  width: 120px;
  flex-shrink: 0;
}

.search-option select {
  width: 100%;
  height: 60px;
  padding: 0 42px 0 20px;

  border: 1px solid #666666;
  border-radius: 6px;
  background-color: #fff;

  font-size: 16px;

  cursor: pointer;
  outline: none;
}

/* 화살표 */
.search-option::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 18px;

  width: 8px;
  height: 8px;

  border-right: 2px solid #666666;
  border-bottom: 2px solid #666666;

  transform: translateY(-65%) rotate(45deg);
  pointer-events: none;
}

@media (max-width: 1024px) {
  .search-option {
    width: 110px;
  }
  .search-option select {
    height: 52px;
    font-size: 14px;
    padding: 0 36px 0 14px;
  }
  .search-data-title-text {
    font-size: 18px;
  }
  .search-data-path-text {
    font-size: 13px;
  }
  .search-data-badge {
    font-size: 12px;
  }
  .search-col-left-text {
    font-size: 15px;
  }
  .search-col-right-text {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .search-option {
    width: 90px;
  }
  .search-option select {
    height: 40px;
    font-size: 12px;
    padding: 0 28px 0 10px;
  }
  .search-option::after {
    right: 12px;
    width: 6px;
    height: 6px;
  }
  .search-data-title-text {
    font-size: 15px;
  }
  .search-data-path-text {
    font-size: 12px;
  }
  .search-data-badge {
    font-size: 11px;
  }
  .search-col-left-text {
    font-size: 15px;
  }
  .search-col-right-text {
    font-size: 15px;
  }
  .search-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .search-col-header,
  .search-result-list,
  .search-result-item,
  .search-item-row {
    min-width: 560px;
  }
}
</style>
